const toast =require('react-toastify').toast;


module.exports.showErrorAlert = function(errorMessage)
{
    toast.error(errorMessage,
    {
        position: "top-center",
        closeOnClick:true,
    });
}

module.exports.showInfoAlert = function(errorMessage)
{
    toast.info(errorMessage,
    {
        position: "top-center",
        closeOnClick:true,
    });
}


module.exports.clearErrors = function()
{
    toast.dismiss();
}